import {
    DefaultButton,
    Dialog, DialogFooter, DialogType, MessageBar, MessageBarType, PrimaryButton,
} from '@fluentui/react'
import React from 'react'
import Status from 'types/status'
import parseJson from 'helpers/methods/parseJson'
import VacationWeek from 'requests/objects/vacationWeek'
import useVacationWeekModal from 'helpers/hooks/components/pages/useVacationWeekModal'
import CompaniesHandler from 'requests/handlers/companiesHandler'
import FilteredVirtualCombobox from 'components/inputs/filteredVirtualCombobox'

/**
 * VacationWeek modal
 * @param {object} props Props
 * @param {Partial<VacationWeek>=} props.vacationWeekdata vacationWeekdata
 * @param {boolean} props.isVisible isVisible
 * @param {object} props.lang Lang
 * @param {CompaniesHandler} props.handler handler
 * @param {(vacationWeek: VacationWeek, isDeletion?: false) => void} props.onChange onChange
 * @param {boolean} [props.isReadOnly] isReadOnly
 * @param {boolean} [props.isDeletion] isDeletion
 * @param {number} props.companyId companyId
 * @returns {JSX.Element} Modal
 */
export default function VacationWeekModal({
    vacationWeekdata,
    isVisible,
    // setIsDeletion,
    lang,
    handler,
    onChange,
    isReadOnly = false,
    isDeletion = false,
    companyId,
}) {
    const {
        tKey,
        tObj,
        errorMessage,
        setErrorMessage,
        onSubmit,
        vacationWeek,
        setVacationWeek,
        errorField,
        status,
        dialogTitle,
        deleteVacationWeek,
    } = useVacationWeekModal({
        lang,
        handler,
        isVisible,
        onChange,
        data: vacationWeekdata,
        companyId,
        isDeletion,
    })

    if (!isVisible)
        return (null)

    const [yearsParam, weeksParam] = (() => {
        const currentYear = new Date().getFullYear()
        const years = [currentYear]
        for (let i = 1; i <= 10; i += 1)
            years.push(currentYear + i)

        const weeks = []
        for (let i = 1; i <= 52; i += 1)
            weeks.push(i)

        return [
            years.map(year => ({ key: year, text: `${tKey('year')} ${year}` })),
            weeks.map(week => ({ key: week, text: tKey('weekNb', { i: week.toString() }) })),
        ]
    })()

    return (
        <Dialog
            hidden={!isVisible}
            dialogContentProps={{
                type: DialogType.largeHeader,
                title: dialogTitle,
            }}
            modalProps={{
                isBlocking: true,
            }}
            // maxWidth="100%"
            // minWidth="1000px"
            maxWidth="555px"
            minWidth="400px"
            styles={{
                main: {
                    width: '100%',
                    maxHeight: '100%',
                    maxWidth: '100%',
                },
            }}
        >
            {errorMessage
                && (
                    <>
                        <MessageBar
                            messageBarType={MessageBarType.error}
                            isMultiline={false}
                            truncated
                            onDismiss={() => setErrorMessage(null)}
                        >
                            {tObj(errorMessage)}
                        </MessageBar>
                        <br />
                    </>
                )}
            <form
                onSubmit={ev => {
                    ev.preventDefault()
                    if (isDeletion)
                        deleteVacationWeek()
                    else
                        onSubmit()
                }}
            >
                {isDeletion ? tKey('sureDeleteVacationWeek') : (
                    <>
                        <FilteredVirtualCombobox
                            label={tKey('year')}
                            placeholder={tKey('year')}
                            options={yearsParam}
                            selectedKey={vacationWeek.year}
                            onChange={(ev, option) => setVacationWeek({
                                ...vacationWeek,
                                year: option.key,
                            })}
                            errorMessage={tObj(parseJson(errorField.year))}
                            readOnly={isReadOnly}
                            required={!isReadOnly}
                        />
                        <br />
                        <FilteredVirtualCombobox
                            label={tKey('week')}
                            placeholder={tKey('week')}
                            options={weeksParam}
                            selectedKey={vacationWeek.week}
                            onChange={(ev, option) => setVacationWeek({
                                ...vacationWeek,
                                week: option.key,
                            })}
                            errorMessage={tObj(parseJson(errorField.week))}
                            readOnly={isReadOnly}
                            required={!isReadOnly}
                        />
                    </>
                )}
                <br />
                <DialogFooter>
                    <DefaultButton
                        onClick={() => onChange(null)}
                        text={tKey('cancel')}
                        disabled={status === Status.PENDING}
                    />
                    <PrimaryButton
                        type="submit"
                        text={tKey(isDeletion ? 'delete' : 'save')}
                        disabled={
                            status === Status.PENDING
                        }
                    />
                </DialogFooter>
            </form>
        </Dialog>
    )
}
